// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","footerChild":"Footer_footerChild__LkrRP","footerText":"Footer_footerText__oR7Uz","author":"Footer_author__UhGVV"};